import { FlexBox } from '@airship-platform/jam-web/components';
import Typography from '@mui/material/Typography';
import { Appointment } from '../../../../data-access/appointments';

type OverviewProps = {
  summaries: Appointment['job']['callSummaries'];
};

const CallSummaries: React.FC<OverviewProps> = ({ summaries }) => {
  const renderSection = (title: string, content: string) => (
    <FlexBox flexDirection={'column'}>
      <Typography variant="subtitle2">{title}</Typography>
      <Typography variant="body2">{content}</Typography>
    </FlexBox>
  );

  return summaries.map((summary) => (
    <FlexBox key={summary.title} flexDirection={'column'} gap={3}>
      {renderSection('Summary Title', summary.title)}
      {renderSection('Summary', summary.callReason)}
      {renderSection('Actions', summary.callAgentActions)}
      {renderSection('Equipment', summary.equipmentMentioned)}
      {renderSection('Constraints', summary.constraints)}
      {renderSection('Notes', summary.specialNotes)}
    </FlexBox>
  ));
};

export default CallSummaries;
